export default __webpack_public_path__ + "cockroach-topview-green.png?8be11edc44063338065da17c0af19b0a";